import React from 'react';
import {View, StyleSheet} from 'react-native';
import AVText from 'src/components/elements/AVText';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import AccountStore from 'src/stores/AccountStore';
import TransactionStore from 'src/stores/TransactionStore';
import Util from 'src/Util';
import {TransactionDetail} from 'src/types/TransactionDetail';
import {ListScanItemsProps} from 'src/components/screens/scanAndPay/listScanItems/ListScanItems';
import {scanAndPayTemplate} from '../templates/scanandPayThemeHelper';

export interface TenderDiscountProps {
  transaction: TransactionDetail | null;
  listProps: ListScanItemsProps;
}

export const TenderDiscount: React.FC<TenderDiscountProps> = ({
  transaction,
  listProps,
}) => {
  if (!transaction) return null;

  const baseDiscount = parseFloat(transaction.PromotionDiscount ?? '0');
  const onScreen = transaction.OnScreenDiscount ?? 0;
  const afterTax = parseFloat(transaction.AfterTaxDiscount ?? '0');

  let total = Math.round((baseDiscount - onScreen) * 100) / 100;
  if (TransactionStore.isAfterTaxPromoApplied()) {
    total = Math.round((total - afterTax) * 100) / 100;
  }

  if (total <= 0) return null;

  const formatted = Util.formatCurrency(
    listProps,
    total,
    AccountStore.getCurrency(),
  );

  return (
    <View
      accessible
      style={styles.container}
      accessibilityLabel="Tender Discount"
    >
      <AVText
        style={styles.text}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
        accessibilityLabel={`${Localized.Labels.formatString(
          Localized.Labels.you_are_saving_amount_by_using_the_app,
          formatted,
        )}`}
        aria-label={`${Localized.Labels.formatString(
          Localized.Labels.you_are_saving_amount_by_using_the_app,
          formatted,
        )}`}
        accessibilityHint={`${Localized.Labels.formatString(
          Localized.Labels.you_are_saving_amount_by_using_the_app,
          formatted,
        )}`}
        accessible
        testID="qa_Checkout.TenderDiscount_txt"
        nativeID="qa_Checkout.TenderDiscount_txt"
      >
        {Localized.Labels.formatString(
          Localized.Labels.you_are_saving_amount_by_using_the_app,
          formatted,
        )}
      </AVText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: Styles.Spacing.m3 + 2,
    marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  text: {
    fontSize: Styles.Fonts.f7,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontStyle: 'italic',
    fontWeight: '400',
    color: scanAndPayTemplate.textColor,
    lineHeight: 20,
  },
});
